export const BUTTON_BRAND_CLASSES = 'btn btn-brand';
export const BUTTON_BRAND_ALT_COLOR_CLASS = 'btn-brand-inverted';
